import { exitLegacy } from './previewFlag';

// Shown only in legacy mode, so nobody sits on the old dashboard thinking it
// is the live site. The current site renders no banner at all.
export const LegacyBanner = () => (
  <div
    style={{
      position: 'fixed',
      bottom: 16,
      left: 16,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      padding: '8px 14px',
      borderRadius: 999,
      background: '#9184d9',
      color: '#161826',
      fontSize: 13,
      fontWeight: 600,
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      boxShadow: '0 4px 14px rgba(0,0,0,0.35)',
    }}
  >
    <span>Legacy view</span>
    <button
      onClick={exitLegacy}
      style={{
        border: '1px solid rgba(22,24,38,0.4)',
        background: 'transparent',
        color: 'inherit',
        borderRadius: 999,
        padding: '3px 10px',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      Current site
    </button>
  </div>
);
